/* Email-capture popup: delayed / exit-intent trigger with suppression.
   - Subscribed once -> never shown again (localStorage, any campaign).
   - Dismissed -> hidden for `dismissDays`, keyed by campaign so a new
     offer (new campaign key) re-arms the popup.
   - The form posts with return_to "?cro-popup=1"; when that param is in
     the URL we show the success view immediately and mark subscribed. */
(function () {
  var SUBSCRIBED_KEY = 'cro-popup:subscribed';

  function init() {
    var popup = document.getElementById('CroPopup');
    if (!popup) return;

    var campaign = popup.dataset.campaign || 'welcome-1';
    var dismissKey = 'cro-popup:dismissed:' + campaign;
    var delayMs = (parseInt(popup.dataset.delay, 10) || 0) * 1000;
    var dismissMs = (parseInt(popup.dataset.dismissDays, 10) || 7) * 86400000;
    var exitIntent = popup.dataset.exitIntent === 'true';
    var posted = new URLSearchParams(window.location.search).get('cro-popup') === '1';
    var opened = false;

    function storageGet(key) {
      try { return window.localStorage.getItem(key); } catch (e) { return null; }
    }
    function storageSet(key, value) {
      try { window.localStorage.setItem(key, value); } catch (e) { /* private mode */ }
    }

    function open() {
      if (opened) return;
      opened = true;
      popup.hidden = false;
      document.documentElement.classList.add('cro-popup-open');
      var input = popup.querySelector('input[type="email"]');
      if (input && !posted) input.focus({ preventScroll: true });
    }

    function close() {
      popup.hidden = true;
      document.documentElement.classList.remove('cro-popup-open');
      storageSet(dismissKey, String(Date.now()));
    }

    popup.querySelectorAll('[data-cro-popup-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !popup.hidden) close();
    });

    if (posted) {
      // Just subscribed via the popup form: show the success view once, then never again.
      storageSet(SUBSCRIBED_KEY, '1');
      var offerView = popup.querySelector('[data-cro-popup-view="offer"]');
      var successView = popup.querySelector('[data-cro-popup-view="success"]');
      if (offerView) offerView.hidden = true;
      if (successView) successView.hidden = false;
      open();
      return;
    }

    if (storageGet(SUBSCRIBED_KEY)) return;

    var dismissedAt = parseInt(storageGet(dismissKey), 10);
    if (dismissedAt && Date.now() - dismissedAt < dismissMs) return;

    window.setTimeout(open, delayMs);

    if (exitIntent && window.matchMedia('(pointer: fine)').matches) {
      document.addEventListener('mouseout', function onExit(event) {
        if (event.relatedTarget || event.clientY > 10) return;
        document.removeEventListener('mouseout', onExit);
        open();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
